/**
 * Product Recommendations Section - Swiper Carousel
 */

(function () {
  'use strict';

  function initProductRecommendations() {
    const sections = document.querySelectorAll('[data-section-type="w-product-recommendations"]');

    sections.forEach((section) => {
      const swiperContainer = section.querySelector('.w-product-recommendations__swiper');
      const prevButton = section.querySelector('.w-product-recommendations__nav-button--prev');
      const nextButton = section.querySelector('.w-product-recommendations__nav-button--next');

      if (!swiperContainer) return;

      // Wait for Swiper to be loaded
      const initSwiper = () => {
        if (typeof Swiper === 'undefined') {
          setTimeout(initSwiper, 100);
          return;
        }

        const swiper = new Swiper(swiperContainer, {
          slidesPerView: 1.2,
          spaceBetween: 16,
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
          },
          breakpoints: {
            // Mobile
            0: {
              slidesPerView: 1.2,
              spaceBetween: 16,
            },
            // Tablet
            768: {
              slidesPerView: 2.5,
              spaceBetween: 20,
            },
            // Desktop
            990: {
              slidesPerView: 4,
              spaceBetween: 28,
            },
          },
          on: {
            init: function () {
              updateNavigationState(this, prevButton, nextButton);
            },
            slideChange: function () {
              updateNavigationState(this, prevButton, nextButton);
            },
            resize: function () {
              updateNavigationState(this, prevButton, nextButton);
            },
          },
        });

        // Store swiper instance for potential cleanup
        swiperContainer.swiper = swiper;
      };

      initSwiper();
    });
  }

  /**
   * Update navigation button states
   */
  function updateNavigationState(swiper, prevButton, nextButton) {
    if (!swiper || !prevButton || !nextButton) return;

    // Disable/enable prev button
    if (swiper.isBeginning) {
      prevButton.setAttribute('disabled', 'disabled');
    } else {
      prevButton.removeAttribute('disabled');
    }

    // Disable/enable next button
    if (swiper.isEnd) {
      nextButton.setAttribute('disabled', 'disabled');
    } else {
      nextButton.removeAttribute('disabled');
    }
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductRecommendations);
  } else {
    initProductRecommendations();
  }

  // Re-initialize on Shopify section load/reload (for theme editor)
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('[data-section-type="w-product-recommendations"]')) {
      initProductRecommendations();
    }
  });
})();
